export {};
//# sourceMappingURL=scene-child.js.map